import { render } from "./BookingLiveChatWidget.vue?vue&type=template&id=ba766a28&scoped=true"
import script from "./BookingLiveChatWidget.vue?vue&type=script&lang=js"
export * from "./BookingLiveChatWidget.vue?vue&type=script&lang=js"

import "./BookingLiveChatWidget.vue?vue&type=style&index=0&id=ba766a28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba766a28"]])

export default __exports__